const shipment = {
  shipmentMana: '배송 요청',
  shipmentListPage: '배송 주문',
  add: '추가',
  edit: '수정',
  delete: '삭제',
  detail: '상세',
  export: '내보내기',
  import: '가져오기',
  search: '조회',
  reset: '초기화',
  confirm: '확인',
  cancel: '취소',
  cancelOk: '취소 성공',
  cancelFAil: '취소 실패',
  confirmCancel: '배송 주문 {{no}}을(를) 취소하시겠습니까?',
  orderNumber: '주문 번호',
  customerName: '고객명',
  status: '상태',
  sourceType: '소스 유형',
  consignee: '수하인',
  consigneeAddress: '수하인 주소',
  consigneePhone: '수하인 연락처',
  destinationCountry: '목적국',
  tradeTerms: '거래 조건',
  paymentTerms: '결제 조건',
  planShipDate: '계획 배송일',
  actualShipDate: '실제 배송일',
  deliveredAt: '배송 완료 시간',
  remark: '비고',
  items: '상세 항목',
  createTime: '생성 시간',
  operation: '작업',
  productCode: '상품 코드',
  productName: '상품명',
  count: '수량',
  saleOrderCount: '판매 주문 수량',
  amount: '금액',
  uom: '단위',
  unitPrice: '단가',
  currency: '통화',
  itemRemark: '항목 비고',
  plKeyword: '주문 번호 또는 고객명 입력',
  shipMethod: '배송 방법',
  shipLogistics: '운송사',
  shipEvent: '물류 추적',
  saleOrder: '판매 주문',
  saleOrderItem: '판매 주문 항목',
  selectOrder: '주문 선택',
  selectOrderItem: '주문 항목 선택',
  noProduct: '상품 없음',
  customerShipAddress: '수하인 주소 선택',
  plCustomerName: '고객명 입력',
  plConsignee: '수하인 입력',
  plConsigneePhone: '수하인 연락처 입력',
  plConsigneeAddress: '수하인 주소 입력',
  plRemark: '비고 입력',
  plTradeTerms: '거래 조건 입력',
  plPaymentTerms: '결제 조건 입력',
  plCurrency: '통화 입력',
  plCarrier: '운송사 입력',
  addPackOrder: '분류 목록 추가',
  yes: '예',
  no: '아니오',
  number: '배송 주문 번호',
  trackingNo: '추적 번호',
  blNo: '선하증권 번호',
  vesselVoyage: '선박/항차',
  containerNo: '컨테이너 번호',
  shipped: '배송 완료',
  pending: '배송 대기',
  shippedAt: '배송 시간',
  freightCost: '운임',
  addLogistics: '물류 추가',
  editLogistics: '물류 수정',
  plTrackingNo: '추적 번호 입력',
  plBlNo: '선하증권 번호 입력',
  plVesselVoyage: '선박/항차/편명 입력',
  plContainerNo: '컨테이너 번호 입력',
  plFreightCost: '운임 입력',
  addError: '추가 실패',
  saveFail: '저장 실패',
  saveOk: '저장 성공',
  addSuccess: '추가 성공',
  freightCurrency: '운임 통화',
  noPackOrder: '분류 목록 없음',
  shipmentNoPack: '배송 주문에 분류 목록이 없어 물류를 추가할 수 없습니다',
  packNoShipment: '분류 목록에 배송 주문이 없어 물류를 추가할 수 없습니다',
  getPackErr: "분류 목록 조회 실패!",
  logistics: "물류 주문",
  eventTime: '이벤트 시간',
  location: '위치',
  description: '설명',
  shipEvents: '물류 추적',
  plLocation: '위치 입력',
  plDescription: '설명 입력',
  addEvent: '추적 추가',
  doShip: '배송',
  shipOk: '배송 성공',
  shipFail: '배송 실패',
  viewLogistics: '물류 보기',
  creator: '생성자',
  viewPackOrder: '분류 목록 보기',
  viewShipmentOrder: '배송 주문 보기',
  repeated: '중복 상품 무시됨',
  addShipOutPl: "배송 출고 주문을 먼저 생성하세요!",
  hasLogis: "이 배송 주문에는 이미 물류 정보가 있습니다",
  plSelShip: "배송 주문을 선택해 주세요",
  plSelShipErr: "동일한 분류 주문에서 생성된 배송 주문만 선택할 수 있습니다",
  exportErr: "내보내기 실패",
};

export default shipment;
